<template>
  <div v-if="mode === 'default'" class="bic-footer-img"><img src="_resources/themes/bic/images/hp-footer.png"></div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.component('BicFooter', {
    props: {
      mode: String,
    },
  });
</script>